<div class="card section">
  <div class="card-body">
    <div class="row">
      <div class="col-1 pt-2">
        <h6>{{ number ?? "#" }}</h6>
      </div>
      <div class="col-9 pt-2 d-flex flex-column gap-1">
        <div class="d-flex flex-wrap gap-1">
          <span
            [innerHTML]="textToDisplay | placeholderHighlight: editor"
          ></span>
          <span class="bold">{{ resource?.name?.trim() }}</span>
          <span
            [innerHTML]="textAfter ?? '' | placeholderHighlight: editor"
          ></span>

          <document-chips
            *ngIf="ppr?.affectedForms?.length"
            [documentChips]="ppr?.affectedForms"
          >
          </document-chips>
        </div>
        <div
          class="d-flex align-items-center gap-1"
          *ngIf="
            validateRS &&
            (ppr?.radSurveyRequired == radSurveyRequired.Required ||
              ppr?.radSurveyAffectedForms?.length)
          "
        >
          <mat-label>Rad Survey Required</mat-label>
          <document-chips
            [documentChips]="ppr?.radSurveyAffectedForms"
            [isRadSurvey]="true"
          >
          </document-chips>
        </div>
      </div>
      <div class="col-2 d-flex flex-row justify-content-end align-items-center suggestion-anchor">
        <mat-icon-with-tootip
          *ngIf="manual"
          (click)="reset()"
          class="warning-icon"
          color="accent"
          icon="warning"
          [toolTipText]="
            documents +
            '<br><span class=\'small\'>This checkbox was manually ' +
            (this.checked ? 'Checked' : 'Unchecked') +
            '<br>[Click to Reset!]</span>'
          "
          toolTipClass="accent-tooltip"
          toolTipPosition="left"
        ></mat-icon-with-tootip>

        <mat-checkbox-with-roles
          [checked]="checked"
          [disabled]="disabled"
          [labelPosition]="'before'"
          [roleCodes]="roleCodes"
          [user]="user"
          [warning]="moreInfo"
          (change)="checkboxChanged($event)"
          color="primary"
          *ngIf="checkboxVisible"
          [date]="date"
        >
        </mat-checkbox-with-roles>
        <mat-icon
          *ngIf="suggested && !checked && !disabled && checkboxVisible"
          class="suggestion-icon"
          [matTooltip]="suggestionTooltip"
          matTooltipPosition="above"
          >lightbulb</mat-icon
        >
      </div>
    </div>
  </div>
</div>
